/* eslint-disable react-hooks/exhaustive-deps */
import { Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchBaseDomain } from "../utils/helpers";
import { CheckAuthnMethod } from "../common";

function Logout() {
  const location = useLocation();
  const { state } = location;
  const [ isTimeOut, setIsTimeOut ] = useState(state?.isTimeOut || false);

  useEffect(() => {
    if(isTimeOut){
      setTimeout(() => {
        logout();
      }, 200); 
      setIsTimeOut(false);
    }else {
      setTimeout(() => {
      logout();
    }, 500);
    }
  }, []);

  const logout = useCallback(() => {

    let CheckUrl = fetchBaseDomain();
    let userRole = localStorage.getItem("UserRole");
    // localStorage.removeItem("token");

    if (CheckUrl === "app.authnull.com" || CheckUrl === "dev.authnull.com") {
      // Clear user session or token here
      localStorage.clear();  
      sessionStorage.clear();
      if (userRole === "SUPERADMIN") {
        window.location.replace(`https://${CheckUrl}/org/login`);
      } else {
        window.location.replace(`https://${CheckUrl}`);
      }
    } else {
      CheckAuthnMethod();
    }
  }, []);

  return (
    <>
      <div className="logout-container">
        <div className="logout-box">
          <div className="text-center">
            <h2 className="text-lg font-semibold">{isTimeOut ? "Session Timeout" : "You have been logged out" }</h2>
          </div>
          <Spin size="large" />
        </div>
      </div>
    </>
  );
}

export default Logout;
